import { observable, action } from 'mobx';
import { HAlign } from '@sprinklr/stories/widget/types';

export type PageNumberAlignment = HAlign;
export type PageNumberIndex = { currentPage: number };

export interface PageNumber {
    enabled?: boolean;
    color?: string;
    size?: number;
    alignment?: PageNumberAlignment;
    total?: number;
    showTotal?: boolean;
}

export interface PageNumberExtended extends PageNumber {
    currentPage: number;
}

export class PageNumberImpl implements PageNumber {
    static readonly graphQLFields: string = `
        enabled
        alignment
        color
        size
        showTotal
    `;
    @observable enabled?: boolean = false;
    @observable alignment?: PageNumberAlignment = 'right';
    @observable color?: string = 'white';
    @observable size?: number = 10;
    @observable total?: number;
    @observable showTotal?: boolean = false;

    @action
    setValues(opts?: any): this {
        if (opts) {
            Object.assign(<any>this, opts);
        }
        return this;
    }
}
